import moment from 'moment'

const SENTINEL_2_API_KEY = '50bf7725-8925-4c63-b3f1-6b7abd0beeaf'
const LANDSAT_8_API_KEY = '161d78f5-7be2-49d4-bce4-0befc6d99d64'
const MODIS_API_KEY = 'bde0458c-2b10-4701-9b0e-7dbe6bd3acf8'
const SENTINEL_1_GRD_API_KEY = '3ec4ee2c-72e8-40d1-8d97-91d354d140e4'
const SENTINEL_2_L1C_API_KEY = '50bf7725-8925-4c63-b3f1-6b7abd0beeaf'

const DATASOURCES = [
  {
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_API_KEY}`,
    index: 'http://services.sentinel-hub.com/index/v3/collections/S2L1C/searchIndex',
    minDate: '2015-01-01',
    id: 'S2',
    name: 'Sentinel-2'
  },
  {
    minDate: '2014-04-03',
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
    id: 'S1_EW',
    name: 'Sentinel-1'
  },
  {
    minDate: '2014-04-03',
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
    id: 'S1_EW_SH',
    name: 'Sentinel-1'
  },
  {
    minDate: '2014-04-03',
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
    id: 'S1',
    name: 'Sentinel-1'
  },
  {
    minDate: '2014-04-03',
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_1_GRD_API_KEY}`,
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v1/finddates',
    id: 'S1-GRD',
    name: 'Sentinel-1 GRD'
  },
  {
    minDate: '2017-03-28',
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v2/finddates/?processingType=1',
    id: 'S2L2A',
    name: 'Sentinel-2 L2A'
  },
  {
    minDate: '2017-03-28',
    url: `https://services.sentinel-hub.com/ogc/wms/${SENTINEL_2_L1C_API_KEY}`,
    index: 'http://services.eocloud.sentinel-hub.com/index/s2/v2/finddates/?processingType=1',
    id: 'S2-L1C',
    name: 'Sentinel-2 L1C'
  },
  {
    minDate: '2016-02-01',
    id: 'S3',
    index: 'http://services.eocloud.sentinel-hub.com/index/s3/v1/finddates',
    name: 'Sentinel-3'
  },
  {
    minDate: '2002-01-01',
    maxDate: '2012-05-01',
    index: 'http://services.eocloud.sentinel-hub.com/index/envisat/v1/finddates',
    id: 'ENV',
    name: 'ENVISAT'
  },
  {
    minDate: '1984-01-01',
    maxDate: '2013-05-01',
    index: 'https://services.sentinel-hub.com/index/landsa5/v2/dates',
    id: 'L5',
    name: 'Landsat 5'
  },
  {
    minDate: '1999-01-01',
    maxDate: '2003-12-01',
    index: 'https://services.sentinel-hub.com/index/landsa7/v2/dates',
    id: 'L7',
    name: 'Landsat 7'
  },
  {
    min: 10,
    minDate: '2013-01-01',
    index: 'https://services.sentinel-hub.com/index/landsa8/v2/dates',
    url: `https://services-uswest2.sentinel-hub.com/v1/wms/${LANDSAT_8_API_KEY}`,
    id: 'L8',
    name: 'Landsat 8'
  },
  {
    min: 5,
    minDate: '2013-01-01',
    index: 'https://services-uswest2.sentinel-hub.com/index/modis/v2/',
    url: `https://services-uswest2.sentinel-hub.com/v1/wms/${MODIS_API_KEY}`,
    id: 'Modis',
    noEffects: true,
    name: 'MODIS'
  }
]
const datasources = DATASOURCES,
  customPreset = {
    CUSTOM: {
      name: 'Custom',
      desc: 'Crear dibujado personalizado',
      image: 'image.jpg'
    }
  },
  VIEWS = {
    PRESETS: '1',
    BANDS: '2',
    SCRIPT: '3'
  }

export default {
  noCredentials: SENTINEL_2_API_KEY === '' && LANDSAT_8_API_KEY === '' && MODIS_API_KEY === '',
  customPreset,
  layers: {
    r: 'B04',
    g: 'B03',
    b: 'B02'
  },
  activeDatasource: {...DATASOURCES[0]},
  startLocation: '',
  doRefresh: true,
  activeBaseLayer: {
    name: '',
    minmax: { min: 0, max: 16 }
  },
  evalscripturl: '',
  isLoaded: true,
  lat: 40.4,
  lng: -3.73,
  zoom: 12,
  size: [0, 0],
  priority: 'mostRecent',
  mosaic: 'mostRecent',
  evalscript: '',
  renderedEvalscript: '',
  opacity: 100,
  maxcc: 20,
  imgWmsUrl: '',
  mapBounds: {},
  minDate: '2015-01-01',
  maxDate: moment(),
  selectedDate: moment(),
  dateFormat: 'YYYY-MM-DD',
  availableDays: [],
  datesCcMap: {},
  onDayPicked: false,
  prevDate: null,
  nextDate: null,
  showDates: false,
  preset: null,
  currView: VIEWS.PRESETS,
  channels: [],
  path: '',
  presets: {
    customPreset
  },
  areaid: "",
  oktPolygons: "",
  token: "",
  instance: "50bf7725-8925-4c63-b3f1-6b7abd0beeaf",
  environment: "prod",
  presetsLegend: [],
  atmFilter: '',
  cloudCorrection: 'none',
  gain: new Number(1).toFixed(1),
  gamma: new Number(1).toFixed(1),
  legendVisible: false,
  devMode: false,
  selectedDevToolsTab: 1,
  devModalVisible: false,
  legendX: 0,
  legendY: 0,
  legendHeight: 0,
  legendWidth: 0,
  legendUrl: null,
  oktAppGUID: "255ksu12-8a16-4ff8-a10d-01200308cu00",
  authenticationUrls: {
    oAuthService: "/rest/ValidoMapaAppCultivosWS",
    generalErrorHandler: "/mensajecore.aspx",
    desa: "http://deploy.okaratech.com/okt-Core-Desa",
    preprod: "https://deploy.okaratech.com/okt-Core-PreProd",
    prod: "https://www.okaratech.com/okt"
  },
  views: VIEWS,
  datasources
}



// WEBPACK FOOTER //
// ./src/store/config.js